export const OLD_VALUES_FORM_ID = 'replaceMeterOldValuesStepForm';
